import { createReducer } from '@reduxjs/toolkit';
import { getContactUsPage } from '../actions/contactPage';

const initialState = {
  loading: true,
  data: { },
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getContactUsPage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
